import { render, staticRenderFns } from "./AuthorizeAdd.form.vue?vue&type=template&id=493f62c2&"
import script from "./AuthorizeAdd.form.vue?vue&type=script&lang=js&"
export * from "./AuthorizeAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports